import { render, staticRenderFns } from "./ClienteCrud.vue?vue&type=template&id=cdd296a2&"
import script from "./ClienteCrud.vue?vue&type=script&lang=js&"
export * from "./ClienteCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports